<script setup lang="ts">
import BaseSticker from "@/components/ui/BaseSticker/BaseSticker.vue";
import type { Sticker } from "@/model/StickerType";

defineProps<{ sticker: Sticker | null }>();
</script>

<template>
  <div v-if="sticker">
    <div class="sticker-container">
      <BaseSticker :sticker />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sticker-container {
  display: flex;
  align-items: center;
}

.sticker-icon {
  height: 14px;
  padding: 0;
}
</style>
